<div [@scaleIn] *ngIf="visible" class="dialog">

  <div class="row nav-container">
    <div class="col-lg-6 col-sm-12 align-self-center">
      <ul class="nav flex-column" (click)="close()">

        <li class="nav-item" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }">
          <a class="nav-link" [routerLink]="['/concert']">Spectacular Concert</a>
        </li>
        <!-- <li class="nav-item" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }">
          <a class="nav-link" (click)="liveStream()">Live Feed</a>
        </li> -->
        <li class="nav-item" routerLinkActive="active">
          <a class="nav-link" [routerLink]="['/home']">Home</a>
        </li>
        <li class="nav-item" routerLinkActive="active">
          <a class="nav-link" [routerLink]="['/about-us']">About Us</a>
        </li>
        <li class="nav-item" routerLinkActive="active">
          <a class="nav-link" [routerLink]="['/team']">Team</a>
        </li>
        <li class="nav-item" routerLinkActive="active">
          <a class="nav-link" [routerLink]="['/managed-events']">Managed Events</a>
        </li>
        <li class="nav-item" routerLinkActive="active">
          <a class="nav-link" [routerLink]="['/managed-artists']">Managed Artists</a>
        </li>
        <li class="nav-item" routerLinkActive="active">
          <a class="nav-link" [routerLink]="['/contact-us']">Contact Us</a>
        </li>
      </ul>
    </div>
  </div>
  <!-- <button *ngIf="closable" (click)="close()" aria-label="Close" class="dialog__close-btn">&#10006;</button> -->
</div>
<!-- <div *ngIf="visible" class="overlay" (click)="close()"></div> -->
